import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notificationData",
  initialState: {
    notification: 0,
    video_notification: [],
    isNotification: false,
  },
  reducers: {
    setVideoNotification: (state, action) => {
      const identity = action.payload.id || action.payload.title;
      const index = state.video_notification.findIndex(
        (item) => (item.id || item.title) === identity,
      );
      if (index >= 0) {
        state.video_notification[index] = action.payload;
      } else {
        state.video_notification.push(action.payload);
      }
    },
    removeVideoNotification: (state, action) => {
      state.video_notification = state.video_notification.filter(
        (item) => (item.id || item.title) !== action.payload,
      );
    },
    setNotificationOpen: (state, action) => {
      state.isNotification = action.payload;
    },
  },
});

export const { setVideoNotification, removeVideoNotification, setNotificationOpen } =
  notificationSlice.actions;

export default notificationSlice.reducer;
